import type {
	JSONSchema,
	JSONSchemaArray,
} from '@/shared/tools/json-schema-utils'

import { useFieldArray, useFormContext } from 'react-hook-form'

import { useColumnsSchemaQuery } from '@/entities/column'

import { HiddenOnContext } from '@/shared/generated'

import { PriceLimitsFields } from './PriceLimitsFields'

type PriceLimitEntity = {
	name: string
	on_violation: string
	type: string
	value: string
}

export function PriceLimitsFieldController({
	name,
	schema,
}: {
	name: string
	schema: JSONSchema
}) {
	const { control } = useFormContext()
	const { data: columns } = useColumnsSchemaQuery(HiddenOnContext.PriceLimits)
	const { fields, append, remove } = useFieldArray({
		control,
		name,
	})

	return (
		<PriceLimitsFields
			columns={columns}
			schema={schema as JSONSchemaArray<PriceLimitEntity>}
			name={name}
			fields={fields}
			onAdd={append}
			onRemove={remove}
		/>
	)
}
